import { getEnabledAtDays } from "frontend/src/features/timetable";
import { http } from "../client";
var fallbackValue = "-";
export var getScheduleDays = function (entries) {
    if (entries === void 0) { entries = []; }
    var daysEnabled = entries.reduce(function (acc, entry) { return acc | entry.days_enabled; }, 0);
    return daysEnabled ? getEnabledAtDays(daysEnabled) : fallbackValue;
};
var getTimeInMinutes = function (time, isEndTime) {
    if (isEndTime === void 0) { isEndTime = false; }
    var _a = time.split(":").map(Number), hours = _a[0], minutes = _a[1];
    var value = hours * 60 + minutes;
    if (isEndTime && value === 0) {
        return 24 * 60;
    }
    return value;
};
var formatMinutesAsTime = function (minutes) {
    var normalized = minutes === 24 * 60 ? 0 : minutes;
    var hours = Math.floor(normalized / 60)
        .toString()
        .padStart(2, "0");
    var mins = (normalized % 60).toString().padStart(2, "0");
    return hours + ":" + mins;
};
export var getScheduleTime = function (entries) {
    if (entries === void 0) { entries = []; }
    if (entries.length === 0) {
        return fallbackValue;
    }
    var starts = entries.map(function (entry) { return getTimeInMinutes(entry.time_start); });
    var ends = entries.map(function (entry) { return getTimeInMinutes(entry.time_end, true); });
    return formatMinutesAsTime(Math.min.apply(Math, starts)) + " - " + formatMinutesAsTime(Math.max.apply(Math, ends));
};
export var getAllTimetables = function () {
    return http.api
        .get("timetables")
        .then(function (response) { return response.data.data; })
        .then(function (timetables) {
        return timetables.map(function (_a) {
            var id = _a.id, title = _a.title, client_id = _a.client_id, used_by = _a.used_by, entries = _a.entries;
            return ({
                id: id,
                title: title,
                usedBy: used_by,
                userId: client_id,
                scheduleDays: getScheduleDays(entries),
                scheduleTime: getScheduleTime(entries),
            });
        });
    });
};
